import { render, staticRenderFns } from "./ingredient-modal.vue?vue&type=template&id=64eb8a5f&"
import script from "./ingredient-modal.vue?vue&type=script&lang=js&"
export * from "./ingredient-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports